import type {
    Product,
    ProductAttribute,
    NormalizedProductAttribute, 
    ProductStockTag,
    ProductListItem,
} from "@songfinch/types";

import {isNumber} from "../validators";

export const normalizeProductAttribute = (productAttributes: ProductAttribute[]): NormalizedProductAttribute | undefined => {
    if (!productAttributes) return undefined;
    const normalizedProductAttributes: NormalizedProductAttribute = {};

    productAttributes.forEach((productAttribute) => {
        const attributeKey = productAttribute.description.toLowerCase();
        normalizedProductAttributes[attributeKey] = {
            title: productAttribute.description,
            values: productAttribute.product_options_attributes.map(attributeValue => {
                if (productAttribute.select_type === "color") {
                    return {
                        key: attributeValue.description,
                        value: attributeValue.description,
                        color: attributeValue.hex_color,
                    };
                } else {
                    return {
                        key: attributeValue.description,
                        value: attributeValue.description,
                        image: attributeValue.image,
                    };
                }

            }),
            type: productAttribute.select_type || "select"
        };
    });

    return normalizedProductAttributes;
};

export const normalizeProductOutOfStock = (inStock: number | null | undefined): boolean => {
    if (!isNumber(inStock) || inStock !== 0) return false;
    return true;
};

export const normalizeProductStockTag = (product: Product | ProductListItem): ProductStockTag | undefined => {
    if (!product.tracks_inventory) return undefined;
    const stock = product.in_stock;
    if (!isNumber(stock) || stock >= 10) return undefined;
    if (normalizeProductOutOfStock(stock)) return {label: "Out of Stock", tagColor: "black-20"};
    if (stock === 1) return {label: "Last One", tagColor: "blue"};
    if (stock < 5) return {label: "Only a Few Left", tagColor: "blue"};
    return {label: "Running Low", tagColor: "blue"};
};